import { render, staticRenderFns } from "./SeguroTab.vue?vue&type=template&id=24ab0f87"
import script from "./SeguroTab.vue?vue&type=script&lang=js"
export * from "./SeguroTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports